const tagFilterBottom = $('.js-filter-bottom')[0]
const filterButton = $('.js-filter-submit')[0]

const changeWidth = (entries) => {
    const entriesState = !entries[0].isIntersecting && window.screen.width > 479
    $(filterButton).toggleClass('modal-tags__submit--in-modal', entriesState)
}
if (tagFilterBottom && filterButton) {
    const observer = new IntersectionObserver(changeWidth, { rootMargin: '0px 0px -35px 0px' });
    observer.observe(tagFilterBottom);
}